import React, { useRef, useState, useCallback, useMemo } from 'react';
import { Capacitor } from '@capacitor/core';
import { google, outlook, ics } from "calendar-link";

import useScreenWidth from '../../generic/hooks/useScreenWidth';
import useModal from '../../modals/hooks/useModal';

import { ModalTypes } from '~/wl-core/types/Modals';

const AddToCalendarButton = ({ event, openInModal = false }) => {
    const buttonRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const screenWidth = useScreenWidth();

    const { newModal, closeModal } = useModal({
        desktop: ModalTypes.Center,
        mobile: ModalTypes.Mobile,
    });

    const calendarLinks = useMemo(() => ({
        Google: google(event),
        'iCal': ics(event),
        Outlook: outlook(event),
    }), [event]);

    const handleLinkClick = useCallback((link) => {
        try {
            window.open(link, '_blank');
        } catch (error) {
            console.error('Error opening calendar link:', error);
        }
        setIsOpen(false);
        if (openInModal) {
            closeModal();
        }
    }, [setIsOpen, openInModal, closeModal]);

    const DropdownContent = useCallback(() => (
        <ul className="event-calendar-dropdown">
            {Object.entries(calendarLinks).map(([name, link], index) => (
                <li
                    onClick={() => handleLinkClick(link)}
                    className="event-calendar-item"
                    key={`calendar-option-${name}-${index}`}
                >
                    {name}
                </li>
            ))}
        </ul>
    ), [calendarLinks, handleLinkClick]);


    const handleToggle = useCallback(() => {
        if (openInModal) {
            newModal(
                <div className="event-calendar-modal">
                    <h3>Add to Calendar</h3>
                    <DropdownContent />
                </div>,
                {
                    title: 'Add to Calendar',
                    closeOnClickOutside: true,
                }
            );
        } else {
            setIsOpen((prev) => !prev);
        }
    }, [screenWidth, openInModal, newModal, DropdownContent]);

    return (
        <div>
            <button
                ref={buttonRef}
                type="button"
                onClick={handleToggle}
                className="join-event-button calendar-event-btn button-reset"
            >
                Add to Calendar
            </button>
            {isOpen && !openInModal && (
                <div>
                    <div className="event-calendar-dropdown-background" onClick={() => setIsOpen(false)} />
                    <DropdownContent />
                </div>
            )}
        </div>
    );
};

export default AddToCalendarButton;